import { Injectable } from '@angular/core';

import { DifferingUnspscModel } from '../../models/DifferingUnspscModel';
import { XRefs } from '../../Xrefs/xrefsDataModel';
import { BaseApiService } from '../base-api.service';
import { UserService } from '../user/user.service';

@Injectable({
  providedIn: 'root',
})
export class DifferingUnspscService {
  baseUrl = window.location.origin;
  token = '';
  canEdit: boolean = false;
  UnspscCodes?: string;

  constructor(
    private baseAPIService: BaseApiService,
    public user: UserService,
  ) {
    this.user.token.subscribe(value => {
      this.token = value;
    });
    user.canEdit.subscribe(v => {
      this.canEdit = v;
    });
  }

  DifferingUnspsc(parameters: DifferingUnspscModel): Promise<XRefs[]> {
    let url = this.baseUrl + '/api/unspsc/DifferingUnspsc';

    this.baseAPIService.headerToken = this.token;
    return this.baseAPIService.postTU<DifferingUnspscModel, XRefs[]>(
      url,
      parameters,
    );
  }

  public exportAuditReport() {
    const fileLoc = this.baseUrl + '/api/unspsc/DownloadAuditReport';
    this.baseAPIService.headerToken = this.token;
    return this.baseAPIService.downloadFile(fileLoc);
  }

  public exportUnspcItems(unspscCodes: string) {
    const fileLoc =
      this.baseUrl +
      '/api/unspsc/DownloadUNSPSCExcel?unspscCodes=' +
      unspscCodes;
    this.baseAPIService.headerToken = this.token;
    return this.baseAPIService.downloadFile(fileLoc);
  }
}
